/**
 * Startseite „Aus der Community“ (Marcel 2026-10-08) – REINE Logik, EINE Stelle (Web-Gegenstück:
 * App `home_community_section_helper.dart`). Die Sektion ist eine Variante von „Neu bei DartCloud“
 * (NeuBeiDartCloudSection) an der alten Stelle von „Darts-Wissen“: nur Beiträge, Forum-Themen,
 * Dart-Setups und Dart-Rooms, neueste zuerst.
 */

export type NeuSectionVariant = 'all' | 'community';

/** Slider-Location je Variante (Backend-Katalog `constants/slider-locations.js`) */
export const SECTION_SLIDER_LOCATION: Record<NeuSectionVariant, string> = {
  all: 'new_entries_home',
  community: 'home_community',
};

/** Welche Quellen lädt die Variante? (Reihenfolge ohne Bedeutung – gemischt wird nach Zeit) */
export const SECTION_SOURCES: Record<NeuSectionVariant, readonly string[]> = {
  all: ['listings', 'profiles', 'setups', 'posts', 'forum'],
  community: ['posts', 'forum', 'setups', 'dartRooms'],
};

export const sectionLoads = (variant: NeuSectionVariant, source: string): boolean => SECTION_SOURCES[variant].includes(source);

/** Höchstzahl Karten je Variante */
export const SECTION_MAX_ITEMS = 14;

/** Sekunden → Millisekunden normalisieren (Backend liefert createdAt teils in s) */
export const toMillis = (value: number | null | undefined): number => {
  if (!value || !Number.isFinite(value)) return 0;
  return value < 1e12 ? value * 1000 : value;
};

/** Zeit eines Dart-Rooms für die Sortierung: letzte Raum-Änderung, sonst Mitglied seit (Bestandsräume ohne updatedAt) */
export const dartRoomTime = (room: { updatedAt?: number | null; memberSince?: number | null }): number =>
  toMillis(room.updatedAt) || toMillis(room.memberSince);

/** Neueste zuerst, auf max kappen (pure) */
export function mergeNewest<T extends { createdAt: number }>(lists: T[][], max = SECTION_MAX_ITEMS): T[] {
  return lists.flat().sort((a, b) => b.createdAt - a.createdAt).slice(0, max);
}
